import { Box } from "@chakra-ui/react";
import { useEffect } from "react";
import { useState } from "react";
import ReactApexChart from "react-apexcharts";

export default function DoubleChart({ pending, ongoing, completed }) {
  useEffect(() => {
    setChart({
      series: [
        {
          name: "Completed task",
          data: completed,
        },
        {
          name: "Pending task",
          data: pending,
        },
        {
          name: "Ongoing tasks",
          data: ongoing,
        },
      ],
    });
  }, [pending, ongoing, completed]);

  const [chart, setChart] = useState({
    series: [
      {
        name: "Completed task",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        name: "Pending task",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        name: "Ongoing tasks",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
      yaxis: {
        title: {
          text: "Total assigned tasks",
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val;
          },
        },
      },
    },
  });
  return (
    <Box w="100%">
      <ReactApexChart
        options={chart.options}
        series={chart.series}
        type="bar"
        height={350}
        width="100%"
      />
    </Box>
  );
}
